export const MAX_INVITE_CHAT_NOTE = 200